/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Facts_MistralInputs */

const en_about_facts_mistral = /** @type {(inputs: About_Facts_MistralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by Mistral AI`)
};

const de_about_facts_mistral = /** @type {(inputs: About_Facts_MistralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by Mistral AI`)
};

const fr_about_facts_mistral = /** @type {(inputs: About_Facts_MistralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propulsé par Mistral AI`)
};

const es_about_facts_mistral = /** @type {(inputs: About_Facts_MistralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impulsado por Mistral AI`)
};

const it_about_facts_mistral = /** @type {(inputs: About_Facts_MistralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basato su Mistral AI`)
};

const nl_about_facts_mistral = /** @type {(inputs: About_Facts_MistralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangedreven door Mistral AI`)
};

const pl_about_facts_mistral = /** @type {(inputs: About_Facts_MistralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napedzana przez Mistral AI`)
};

const fi_about_facts_mistral = /** @type {(inputs: About_Facts_MistralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistral AI:n voimalla`)
};

const da_about_facts_mistral = /** @type {(inputs: About_Facts_MistralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drevet af Mistral AI`)
};

const sv_about_facts_mistral = /** @type {(inputs: About_Facts_MistralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drivs av Mistral AI`)
};

/**
* | output |
* | --- |
* | "Powered by Mistral AI" |
*
* @param {About_Facts_MistralInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_facts_mistral = /** @type {((inputs?: About_Facts_MistralInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Facts_MistralInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_facts_mistral(inputs)
	if (locale === "fr") return fr_about_facts_mistral(inputs)
	if (locale === "es") return es_about_facts_mistral(inputs)
	if (locale === "it") return it_about_facts_mistral(inputs)
	if (locale === "nl") return nl_about_facts_mistral(inputs)
	if (locale === "pl") return pl_about_facts_mistral(inputs)
	if (locale === "fi") return fi_about_facts_mistral(inputs)
	if (locale === "da") return da_about_facts_mistral(inputs)
	if (locale === "sv") return sv_about_facts_mistral(inputs)
	return en_about_facts_mistral(inputs)
});